import React, { memo, useState, useRef, useEffect } from "react";
import Moveable from "react-moveable";
import MoveableHelper from "moveable-helper";

const DimensionViewable = {
  name: "dimensionViewable",
  props: {},
  events: {},
  render(moveable, React) {
    const rect = moveable.getRect();
    return (
      <div
        key={"dimension-viewer"}
        className={"moveable-dimension"}
        style={{
          position: "absolute",
          left: `${rect.width / 2}px`,
          top: `${rect.height + 20}px`,
          background: "#4af",
          borderRadius: "2px",
          padding: "2px 4px",
          color: "white",
          fontSize: "13px",
          whiteSpace: "nowrap",
          fontWeight: "bold",
          willChange: "transform",
          transform: "translate(-50%, 0px)",
        }}
      >
        {Math.round(rect.offsetWidth)} x {Math.round(rect.offsetHeight)}
      </div>
    );
  },
};

const TextComponent = ({ data, onHandledelete, onChangeText, onSelected }) => {
  const [state, setstate] = useState({
    html: data.data.body,
  });

  const [helper] = React.useState(() => {
    return new MoveableHelper();
  });
  const targetRef = React.useRef(null);

  
  const [frame, setFrame] = React.useState({
    translate: [100, 100],
    rotate: 0,
    transformOrigin: "50% 50%",
  });

  React.useEffect(() => {
    setTarget(document.querySelector(".target"));
  }, []);

  const [textProp, setTextProp] = useState({
    bgColor: "",
    color: "",
    bold: false,
    italics: false,
    textalign: "left",
  });
  const [heading, setHeading] = useState(48);
  const [isDraggable, setIsDraggable] = useState(false);
  const [target, setTarget] = React.useState();
  const [isVisible, setIsVisible] = useState(false);

  const getBackgroundColor = (color) => {
    console.log(color);
    setTextProp({ ...textProp, bgColor: color });
  };

  const getTextColor = (color) => {
    setTextProp({ ...textProp, color: color });
  };

  const getHeading = (option) => {
    setHeading(option.size);
  };

  const getTextStyle = (textFormat) => {
    setTextProp({
      ...textProp,
      bold: textFormat.bold,
      italics: textFormat.italics,
    });
  };

  const getTextAlignment = (alignment) => {
    console.log("i am the alignment", alignment);
    setTextProp({
      ...textProp,
      textalign: alignment,
    });
  };

  const toggleLock = () => {
    setIsDraggable(!isDraggable);
  };

  useEffect(() => {
  }, [isDraggable, isVisible]);

  const handleVisible = (e) => {
    if (e.type === "click") {
      setIsVisible(!isVisible);
    } else if (e.type === "contextmenu") {
      setIsVisible(true);
    }
  };

  return (
    <div
      key={data.id}
      style={{ width: 600 }}
      className="text--target block-wrapper"
      onContextMenu={handleVisible}
      onClick={onSelected}
    >
      <div>
        <input
          ref={targetRef}
          type="text"
          name="heading"
          value={data.data.body}
          onChange={(e) => onChangeText(e, data.id)}
          style={{
            width: 600,
            border: "none",
            backgroundColor: textProp.bgColor.hex
              ? textProp.bgColor.hex
              : "transparent",
            color: textProp.color.hex,
            fontSize: heading,
            fontWeight: textProp.bold ? "bold" : "normal",
            fontStyle: textProp.italics ? "italic" : "normal",
            textAlign: textProp.textalign,
            padding: `8px 16px`,
          }}
          onClick={onSelected}
        />
        {/* <Moveable
          target={targetRef}
          ables={[DimensionViewable]}
          props={{
            dimensionViewable: true,
          }}
          draggable={true}
          resizable={true}
          scalable={true}
          rotatable={true}
          onDragStart={helper.onDragStart}
          onDrag={helper.onDrag}
          onResizeStart={helper.onResizeStart}
          onResize={helper.onResize}
          onRotateStart={helper.onRotateStart}
          onRotate={helper.onRotate}
        /> */}
      </div>
    </div>
  );
};

export default memo(TextComponent);
